import { Grid } from 'antd';

const { useBreakpoint } = Grid;

/**
 * Form label'ı — iki kullanım:
 *   external={false} → Input/InputNumber'ın addonBefore slot'u (antd zaten .ant-input-group-addon
 *                      kabuğunu ve zeminini basar; burada sadece metin biçimlenir).
 *   external={true}  → Input'un DIŞINDA, kendi başına duran addon bloğu (Kimlik, Cinsiyet,
 *                      Doğum Tarihi). antd v5'te .ant-input-number-group-addon stilleri hash'li
 *                      bileşen sınıfına bağlı ve bileşen dışında UYGULANMIYOR — zemin/padding/
 *                      yükseklik burada açıkça verilmeli, yoksa label şeffaf zeminde kayboluyor.
 */
const AddonBefore = ({ width, external, style = {}, children }) => {
    const screens = useBreakpoint();
    const isMobile = !screens.md;
    // Mobilde geniş label'lar input alanını eziyor — 70px'i geçmesin
    const effectiveWidth = isMobile ? Math.min(width, 70) : width;
    // Kontrol yüksekliği: compact algoritmada 28px; mobilde input 38px
    const controlHeight = isMobile ? 38 : 28;

    // Label metni renkli kart zeminlerinin (cinsiyet kutusu) üstünde de okunmalı.
    // nowrap: sabit genişlikli addon kutusunda "Doğum Tarihi" iki satıra kırılmasın.
    const labelText = {
        fontWeight: 600,
        color: 'var(--text)',
        fontSize: isMobile ? 12 : 13,
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
    };

    if (external) {
        return (
            <div
                style={{
                    width: `${effectiveWidth}px`,
                    minWidth: `${effectiveWidth}px`,
                    height: controlHeight,
                    background: 'var(--surface-2)',
                    border: '1px solid #d9d9d9',
                    borderRadius: 6,
                    textAlign: 'start',
                    display: 'flex',
                    alignItems: 'center',
                    padding: isMobile ? '0 6px' : '0 8px',
                    boxSizing: 'border-box',
                    ...labelText,
                    ...style
                }}
            >
                {children}
            </div>
        )
    }

    return (
        <div
            style={{
                width: effectiveWidth,
                minWidth: effectiveWidth,
                minHeight: isMobile ? controlHeight : undefined,
                textAlign: 'start',
                display: 'flex',
                alignItems: 'center',
                ...labelText,
                ...style
            }}
        >
            {children}
        </div>
    )
}

export default AddonBefore
